/* Home hero: cross-fades plates already in the DOM, stacked in one grid cell.
   The server picks them and the opening one, so this only shuffles what follows,
   runs the rotation and keeps the markers in sync. */
(function () {
  const bq = window.bq;
  if (!bq) return;

  // Long enough to read a chapo.
  const DELAY = 8000;

  function init(root) {
    if (!root || root.dataset.bqHeroInit) return;
    root.dataset.bqHeroInit = '1';

    const slides = Array.from(root.querySelectorAll('[data-bq-hero-slide]'));
    if (slides.length < 2) return;

    const imgs = Array.from(root.querySelectorAll('.bq-hero__img'));
    const legends = Array.from(root.querySelectorAll('[data-bq-hero-legend]'));
    const dots = Array.from(root.querySelectorAll('[data-bq-hero-dot]'));
    const live = root.querySelector('[data-bq-hero-live]');

    // A plate missing a photograph or names leaves a shorter list; drop that
    // column from the rotation rather than pairing it off by one.
    const withImgs = imgs.length === slides.length;
    const withLegends = legends.length === slides.length;

    // The opening plate is the one bq-prepaint drew before first paint, falling
    // back to the one Liquid opened on. The rest is shuffled behind it.
    const doc = document.documentElement;
    const stamped = parseInt(doc.getAttribute('data-bq-plate'), 10);
    const start = stamped >= 0 && stamped < slides.length
      ? stamped
      : Math.max(0, slides.indexOf(root.querySelector('.bq-hero__slide.is-active')));

    const order = slides.map(function (_, n) { return n; });
    order.splice(order.indexOf(start), 1);
    for (let i = order.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      const swap = order[i];
      order[i] = order[j];
      order[j] = swap;
    }
    order.unshift(start);

    let pos = 0;
    let timer = null;
    // Reduced motion opens on the drawn plate and stays; the markers keep
    // working, since a requested change is not motion.
    let stopped = bq.reducedMotion();

    function mark(set, i) {
      set.forEach(function (el, n) {
        el.classList.toggle('is-active', n === i);
      });
    }

    function show(index) {
      mark(slides, index);
      if (withImgs) mark(imgs, index);
      if (withLegends) mark(legends, index);
      dots.forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === index);
        if (n === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    // aria-live is off while the rotation runs, or a reader hears the hero every
    // eight seconds; it comes back the moment the rotation stops.
    function play() {
      if (timer || stopped) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        pos = (pos + 1) % order.length;
        show(order[pos]);
      }, DELAY);
      if (live) live.setAttribute('aria-live', 'off');
    }

    function pause() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (live) live.setAttribute('aria-live', 'polite');
    }

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () {
        // An explicit choice ends the rotation for the visit.
        stopped = true;
        pause();
        show(n);
      });
    });

    show(start);
    doc.removeAttribute('data-bq-plate');

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', play);

    play();
  }

  document.querySelectorAll('[data-bq-hero]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bq-hero]').forEach(init);
  });
})();
